import O1HD from "../../../../engines/gameEngine";
import { NormalStockPriceI } from "../../manager/DefineInterface";
import NormalGameManager from "../../manager/NormalGameManager";
import StockPutInPrefab from "./StockPutInPrefab ";
const { ccclass, property } = cc._decorator;

@ccclass
export default class StockBankruptcyItem extends cc.Component {

    @property(cc.Label)
    stockTime: cc.Label = null

    @property(cc.Label)
    stockName: cc.Label = null

    bindData(stockPrice: NormalStockPriceI) {
        this.stockName.string = stockPrice.name;
        if (stockPrice.name.length == 4) {
            this.stockName.node.width = 60
        }else{
            this.stockName.node.width = 80
        }
        let nowTime = NormalGameManager._instance.mMinute + NormalGameManager._instance.mGameHours * 60
        let house = Math.floor((stockPrice.bankruptcy - nowTime) / 60)
        let minute = Math.floor((stockPrice.bankruptcy - nowTime) % 60)
        this.stockTime.string = `破产重组中      ` + (house < 10 ? "0" + house : house) + ":" + (minute < 10 ? "0" + minute : minute)
        this.schedule(() => {
            nowTime = NormalGameManager._instance.mMinute + NormalGameManager._instance.mGameHours * 60
            house = Math.floor((stockPrice.bankruptcy - nowTime) / 60)
            minute = Math.floor((stockPrice.bankruptcy - nowTime) % 60)
            this.stockTime.string = `破产重组中      ` + (house < 10 ? "0" + house : house) + ":" + (minute < 10 ? "0" + minute : minute)
            if (stockPrice.bankruptcy <= nowTime) {
                O1HD.emit(StockPutInPrefab.REST_STOCK_MESSAGE, false,false)
            }
        }, 1)
    }

    onDisable() {
        this.unscheduleAllCallbacks()
    }
}
